// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDlSw-0qxTpYgomCnxWyuZ-1ANDYvBimiY",
    authDomain: "glastonbury-budget.firebaseapp.com",
    projectId: "glastonbury-budget",
    storageBucket: "glastonbury-budget.firebasestorage.app",
    messagingSenderId: "447028578275",
    appId: "1:447028578275:web:d54be8e00d0fea578f82d6",
    measurementId: "G-JBWRS8YXRG"
  };
  
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

// Make persistence explicit
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Could not set Firebase auth persistence:", error);
});

export { auth, db, functions };
